module.exports = "<div class=\"ui-select-wrapper\" ng-if=\"$ctrl.mode === 'edit'\">\n    <selector\n        model=\"$ctrl.ngModel\"\n        multi=\"true\"\n        remote=\"$ctrl.refresh(search)\"\n        create=\"$ctrl.create(input)\"\n        option-comparator=\"$ctrl.customOptionComparator\"\n        placeholder=\"Type to search...\">\n    </selector>\n</div>\n<span ng-if=\"$ctrl.mode === 'view'\" ng-bind=\"$ctrl.shipTo || '-'\"></span>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/directives/ship.to.picker.html
// module id = 580
// module chunks = 0